import { render, staticRenderFns } from "./footerVue.vue?vue&type=template&id=7b646d28&scoped=true&"
import script from "./footerVue.vue?vue&type=script&lang=js&"
export * from "./footerVue.vue?vue&type=script&lang=js&"
import style0 from "./footerVue.vue?vue&type=style&index=0&id=7b646d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b646d28",
  null
  
)

export default component.exports